/**
 * Register vizuálnych šablón (templatov) obrazovky denného menu.
 *
 * Každá šablóna má vlastné komponenty pre landscape aj portrait. Konkrétny kód
 * teda jednoznačne patrí ku konkrétnej šablóne (id "template_1", "template_2", ...).
 * Id šablóny prichádza z URL parametra ?template=... (hodnota z nastavení obrazovky).
 *
 * Pridanie novej šablóny:
 *   1. Vytvor komponenty (landscape + portrait) pre daný dizajn.
 *   2. Pridaj ich sem pod nové id "template_N".
 * Router (DailyMenuScreenRouter) podľa id a orientácie vyberie správny komponent.
 */
import DailyMenuScreenTemplate1Landscape from "./DailyMenuScreen";
import DailyMenuScreenTemplate1Portrait from "./DailyMenuScreenPortrait";
import DailyMenuTemplate2Landscape from "./templates/template2/DailyMenuTemplate2Landscape";
import DailyMenuTemplate2Portrait from "./templates/template2/DailyMenuTemplate2Portrait";

/** Predvolená šablóna, ak URL parameter chýba alebo je neznámy (pôvodný dizajn). */
export const DEFAULT_DAILY_MENU_TEMPLATE = "template_1";

/** Mapa: id šablóny → komponenty pre jednotlivé orientácie. */
export const DAILY_MENU_TEMPLATE_COMPONENTS = {
  // template_1 = pôvodný (doteraz jediný) dizajn.
  template_1: {
    landscape: DailyMenuScreenTemplate1Landscape,
    portrait: DailyMenuScreenTemplate1Portrait,
  },
  // template_2 = svetlý "Restaurant" dizajn.
  template_2: {
    landscape: DailyMenuTemplate2Landscape,
    portrait: DailyMenuTemplate2Portrait,
  },
};

/**
 * Normalizuje id šablóny z URL na známe id; neznáme/prázdne → predvolená šablóna.
 * @param {string} raw
 * @returns {string}
 */
export function resolveDailyMenuTemplateId(raw) {
  const id = String(raw || "").trim();
  return DAILY_MENU_TEMPLATE_COMPONENTS[id] ? id : DEFAULT_DAILY_MENU_TEMPLATE;
}

/**
 * Vráti komponent pre dané id šablóny a orientáciu (s bezpečným fallbackom).
 * @param {string} templateId
 * @param {"landscape"|"portrait"} orientation
 * @returns {React.ComponentType}
 */
export function getDailyMenuTemplateComponent(templateId, orientation) {
  const id = resolveDailyMenuTemplateId(templateId);
  const entry =
    DAILY_MENU_TEMPLATE_COMPONENTS[id] ||
    DAILY_MENU_TEMPLATE_COMPONENTS[DEFAULT_DAILY_MENU_TEMPLATE];
  return orientation === "portrait" ? entry.portrait : entry.landscape;
}
